<template>
  <main class="app-container">
    <list-loading v-show="loading" />
    <div class="no-result" v-show="!loading && listData.length < 1">没有记录</div>

    <md-field v-for="item in listData"
              :key="item.id">
      <md-detail-item title="日期">
        {{item.start_day}} 至 {{item.end_day}}
        <md-tag size="small" shape="circle" type="fill" fill-color="#FC7353" font-color="#fff" v-if="item.is_trial">体验</md-tag>
      </md-detail-item>
      <md-detail-item title="课时" :content="item.sessions + '次'" />
      <md-detail-item title="联系人" :content="item.caregiver_name" />
      <md-detail-item class="operation" title="联系电话">
        <a :href="'tel:' + item.caregiver_tel">{{item.caregiver_tel}}</a>
      </md-detail-item>
      <md-detail-item title="儿童" :content="item.children" />
      <md-detail-item title="报名时间" :content="item.created_at" />
    </md-field>
  </main>
</template>

<script>
    import { Field, DetailItem,Tag } from 'mand-mobile'
    import ListLoading from "../../components/ListLoading.vue";


export default {
  name: "LeaderEnroll",
  components: {
      ListLoading,
      [Tag.name]: Tag,
      [Field.name]: Field,
      [DetailItem.name]: DetailItem,
  },
    data() {
      return {
          listData:[],
          loading:true,
      }
    },
    created() {
      const courseId = this.$route.query.courseId;
      this.$http.get(`enrolls/${courseId}/leader`)
          .then(({data}) => {
            this.listData = data;
            this.loading = false;
          })
          .catch(() => {
              this.loading = false;
          })

    },
};
</script>


<style lang="scss" scoped>
.md-tag {
  margin-left: 20px;
}

</style>
